// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2zOcO","title":"ClientInsurance_title__3xOEF","itemText":"ClientInsurance_itemText___RaZu"};